export enum UpdateAction {
    REFRESH = 'REFRESH',
    UPDATE_VALUE = 'UPDATE_VALUE',
    UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD',
    UPDATE_HIDDEN_FIELD = 'UPDATE_HIDDEN_FIELD',
    UPDATE_DROPDOWN = 'UPDATE_DROPDOWN'
}
